<template>
    <b-card>
        <b-tabs content-class="mt-3">
            <b-tab title="Pedidos" active>
                <b-card bg-variant="light" data-manual-filter :body-class="filtersOpen ? '' : 'lg-filter-collapsed'">
                    <button type="button"
                        class="btn btn-outline-primary lg-filter-toggle w-100 d-flex justify-content-between align-items-center mb-2"
                        @click="toggleFilters">
                        <span class="d-flex align-items-center">
                            <b-icon icon="funnel" font-scale="1.1" class="mr-2"></b-icon>
                            <span>Filtros</span>
                        </span>
                        <b-icon :icon="filtersOpen ? 'chevron-up' : 'chevron-down'" font-scale="1.1"></b-icon>
                    </button>

                    <div class="lg-filter-container" v-show="filtersOpen">
                        <b-form-row @submit.prevent="load" @keyup.enter="load" class="align-items-end">

                            <b-col lg="2" sm="6">
                                <lg-form-input v-model="form.pedidoId" label="Número:" invalidFeedback=""
                                    description="" />
                            </b-col>
                            <b-col lg="8" sm="12">
                                <lg-finder-page-unidade-administrativa id="finderUnidadeAdministrativa"
                                    v-model="form.departamento" @onselect="handleSelectUnidadeAdministrativa"
                                    :podeMudarDepartamento="temPrivilegioConfigurarAlmoxarifado() || temPrivilegioSelecionarUA()"
                                    :podeApagarDepartamento="temPrivilegioConfigurarAlmoxarifado() || temPrivilegioSelecionarUA()"
                                    invalidFeedback="Informe uma unidade administrativa!" :title="'Departamento'" />
                            </b-col>
                            <b-col lg="2" sm="10" class="text-right d-flex align-items-center justify-content-end">
                                <b-button v-if="temPrivilegioIncluir()" class="ml-2" size="md" variant="success"
                                    style="min-width:100px" title="Novo Pedido" @click="showModalPedidoForm = true">
                                    <div>Novo Pedido</div>
                                </b-button>
                            </b-col>

                            <b-col lg="3" sm="8">
                                <lg-form-select @input="load" v-model="form.status" :loadFunction="statusList"
                                    labelFormGroupBind="Status:" label="descricao" description=" " filterList="true" />
                            </b-col>


                            <b-col lg="7" sm="12">
                                <lg-finder-page-almoxarifado id="finderAlmoxarifado" v-model="form.almoxarifado"
                                    @onselect="handleSelectAlmoxarifado" invalidFeedback="Informe um almoxarifado!"
                                    :prefix="prefix + title + ' > '" />
                            </b-col>
                            <b-col cols="2" class="d-flex align-items-center justify-content-end mt-3">
                                <b-button id="limpar" class="my-2" size="sm" style="height: 40px" pill variant="primary"
                                    @click="clearForm">
                                    <div class="btn-size-alinhamento">
                                        <b-icon icon="eraser" />
                                    </div>
                                    <b-tooltip target="limpar" title="Limpar"></b-tooltip>
                                </b-button>
                                <b-button id="localizar" class="ml-3 my-2" size="sm" style="height: 40px" pill
                                    variant="primary" @click="load">
                                    <div class="btn-size-alinhamento">
                                        <b-icon icon="search" />
                                    </div>
                                    <b-tooltip target="localizar" title="Localizar"></b-tooltip>
                                </b-button>

                            </b-col>

                            <b-col lg="2" sm="6">
                                <lg-form-date v-model="form.dataDe" label="Criação:"
                                    invalidFeedback="A data limite deve ser informada!" description="" />
                            </b-col>
                            <b-col lg="2" sm="6">
                                <lg-form-date v-model="form.dataAte" label="Até:"
                                    invalidFeedback="A data limite deve ser informada!" description="" />
                            </b-col>

                            <b-col lg="6" sm="12">
                                <LgFinderPageProduto id="finderProduto" v-model="form.produto"
                                    @onselect="handleSelectProduto" invalidFeedback="Informe um produto!"
                                    :prefix="prefix + title + ' > '" />
                            </b-col>
                            <b-col cols="2"></b-col>


                            <b-col lg="8" sm="12">
                                <lg-form-input v-model="form.justificativa" label="Justificativa:"
                                    invalidFeedback="A justificativa deve ser informado!" description=""
                                    placeholder="" />
                            </b-col>
                            <b-col lg="2" sm="12" class="d-flex align-items-center">
                                <b-form-checkbox @change="load" v-model="form.descricaoExata" id="checkbox-3" class="ml-1 mb-3">
                                    <span style="font-size: 12px">Descrição Exata</span>
                                </b-form-checkbox>
                            </b-col>

                            <b-col cols="2" class="d-flex align-items-center justify-content-end mt-3">
                                <div :id="'relatorioXlsx'" class="mx-2">
                                    <img @click="chamarModalRelatorioPedidosTarefas('EXCEL')" :src="xlsIcon"
                                        class="img img--clickable" alt="XLSX" />
                                    <b-tooltip :target="'relatorioXlsx'" title="Gerar Relatório XLSX"></b-tooltip>
                                </div>
                                <div :id="'relatorioPdf'" class="mx-2">
                                    <img @click="chamarModalRelatorioPedidosTarefas('PDF')" :src="pdf"
                                        class="img img--clickable" alt="PDF" />
                                    <b-tooltip :target="'relatorioPdf'" title="Gerar Relatório PDF"></b-tooltip>
                                </div>
                            </b-col>
                        </b-form-row>
                    </div>

                    <b-table responsive class="mt-4" small :busy="this.busy" :items="safeRecords" :fields="tableFields"
                        hover show-empty>
                        <template v-slot:cell(id)="row">
                            <a class="link" @click.prevent="detalharPedido(row.item)">{{ row.item.id }}</a>
                        </template>
                        <template v-slot:cell(dhCriacao)="row">
                            {{ formatDate(row.item.dhCriacao || date) }}
                        </template>
                        <template #empty>
                            <p>Nenhum registro encontrado</p>
                        </template>
                        <template v-slot:cell(status)="row">
                            <span class="lg-status"
                                :class="row.item.status.id == 28 ? 'text-red' : 'lg-status__gray--l20'"
                                style="font-size: 13px">
                                {{ row.item.status.descricao }}
                            </span>
                        </template>
                        <template #table-busy>
                            <div class="text-center text-primary my-2">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                        </template>
                        <template v-slot:cell(enviar)="row">
                            <b-button class="my-2" size="sm" :id="`enviar-${row.item.id}`"
                                @click="enviarPedido(row.item)" variant="primary" pill title="Enviar..."
                                v-if="emDigitacao(row.item.status)">
                                <b-icon icon="box-arrow-right" />
                                <b-tooltip :target="`enviar-${row.item.id}`" title="Enviar Pedido"></b-tooltip>
                            </b-button>
                        </template>
                        <template v-slot:cell(editar)="row">
                            <b-button class="my-2" size="sm" :id="`editar-${row.item.id}`"
                                @click="editarPedido(row.item)" variant="primary" title="Editar..." pill
                                v-if="emDigitacao(row.item.status)">
                                <b-icon icon="pencil-square" />
                                <b-tooltip :target="`editar-${row.item.id}`" title="Editar pedido..."></b-tooltip>
                            </b-button>
                        </template>
                        <template v-slot:cell(remover)="row">
                            <b-button :id="`excluir-${row.item.id}`" class="my-2" size="sm"
                                @click="excluirPedido(row.item)" variant="danger" title="Excluir..." pill
                                v-if="emDigitacao(row.item.status)">
                                <b-icon icon="trash2" />
                                <b-tooltip :target="`excluir-${row.item.id}`" title="Excluir pedido..."></b-tooltip>
                            </b-button>
                        </template>
                    </b-table>

                    <b-row style="margin-top: 12px">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                            <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page
                            }} de
                                {{
                                    totalPage }} -
                                {{ total }} registros</b-col>
                            <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                                <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                    :options="perPageOptions">
                                </b-form-select>
                            </b-col>
                        </b-col>
                        <b-col cols="6">
                            <div class="d-flex justify-content-end align-items-end">
                                <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                    :per-page="perPage" :total-rows="total"></b-pagination>
                            </div>
                        </b-col>
                    </b-row>

                    <PedidoForm v-if="showModalPedidoForm" @close="cancelar" @hidden="cancelar" :prefix="'Pedido'"
                        :title="' > Cadastro'" :id="pedidoId" />
                    <TogglePedido :prefix="prefix + title + ' > '" v-if="showModalTogglePedido" @close="cancelar"
                        @hidden="cancelar" :pedido="pedido" />
                    <RelatorioPedidosTarefasForm v-if="showModalRelatorioPedidosTarefas"
                        @close="canelarModalRelatorioPedidosTarefas" @hidden="canelarModalRelatorioPedidosTarefas"
                        :prefix="'Pedido'" :title="' > Relatório de Pedidos e Tarefas'" :tipoArquivo="tipoArqivo"
                        :filtros="form" />
                </b-card>
            </b-tab>

            <b-tab :title="`Tarefas (${this.tarefasAguardando})`">
                <tarefas-list @pesquisouTarefas="pesquisouTarefas"></tarefas-list>
            </b-tab>
        </b-tabs>
    </b-card>
</template>

<script>
import TarefasList from "./TarefasList.vue"
import ResourceService from "@/core/api/ResourceService"
import LgFormDate from "@/core/components/Form/LgFormDate.vue"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import LgFormSelect from "@/core/components/Form/LgFormSelect.vue"
import ConfirmMixin from "@/core/mixins/confirm"
import { FormResourceMixin, ListResourceMixin } from "@/core/mixins/resource"
import moment from "moment"
import Swal from "sweetalert2"
import LgFinderPageUnidadeAdministrativa from "@/components/Finders/LgFinderPageUnidadeAdministrativa.vue"
import LgFinderPageAlmoxarifado from "@/components/Finders/LgFinderPageAlmoxarifado.vue"
import LgFinderPageProduto from "@/components/Finders/LgFinderPageProduto.vue"
import PedidoForm from "./PedidoForm.vue"
import TogglePedido from "./TogglePedido.vue"
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"
import RelatorioPedidosTarefasForm from "@/modules/almoxarifados/pedidos/RelatorioPedidosTarefasForm.vue";
import PdfIcon from "@/core/assets/icons/pdf.png";
import xlsIcon from "@/core/assets/icons/xls.png";

export default {
    components: {
        RelatorioPedidosTarefasForm,
        TarefasList,
        PedidoForm,
        LgFormDate,
        LgFormSelect,
        LgFormInput,
        LgFinderPageUnidadeAdministrativa,
        LgFinderPageAlmoxarifado,
        LgFinderPageProduto,
        TogglePedido,
    },
    props: {
        prefix: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "Pedido",
        },
    },
    data() {
        return {
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            busy: false,
            pedido: {},
            pedidoId: null,
            showModalPedidoForm: false,
            showModalTogglePedido: false,
            showModalRelatorioPedidosTarefas: false,
            filtersOpen: true,
            form: {
                descricaoExata: false,
                numeroPedido: null,
                dataDe: "",
                dataAte: "",
                justificativa: "",
                almoxarifado: {},
                departamento: {},
                produto: {},
                status: { id: null, descricao: "Selecione..." },
            },
            records: [],
            tarefasAguardando: 0,
            pdf: PdfIcon,
            xlsIcon: xlsIcon,
            tipoArqivo: null
        }
    },

    mixins: [ConfirmMixin, ListResourceMixin, FormResourceMixin],

    async beforeMount() {
        const brand = JSON.parse(localStorage.getItem("context"))
        this.form.departamento = brand.departamento
        this.$service = new ResourceService(`/api/pedidos`)
        this.$serviceStatus = new ResourceService(`/api/status/tipo/11`)
        this.$serviceTarefa = new ResourceService(`/api/tarefaspedido`)
        this.form.departamento = JSON.parse(localStorage.getItem("context")).departamento;

        this.load();


    },


    watch: {
        page() {
            this.load()
        },
    },

    computed: {
        tableFields() {
            return [
                {
                    key: "id",
                    label: "Nº",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },

                {
                    key: "justificativa",
                    label: "Justificativa",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },

                {
                    key: "dhCriacao",
                    label: "Data Criação",
                    tdClass: "text-center",
                    thClass: "text-center",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },

                {
                    key: "status",
                    label: "Status",
                    tdClass: "text-center",
                    thClass: "text-center",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: "enviar",
                    label: "",
                    thStyle: "width: 1rem; font-size: 16px; ",
                    tdClass: "text-center ",
                },
                {
                    key: "editar",
                    label: "",
                    thStyle: "width: 1rem; font-size: 16px; ",
                    tdClass: "text-center ",
                },
                {
                    key: "remover",
                    label: "",
                    thStyle: "width: 1rem; font-size: 16px; ",
                    tdClass: "text-center ",
                },
            ]
        },

        safeRecords() {
            return this.records || []
        },

        hasRecords() {
            return Array.isArray(this.records) && this.records.length > 0
        },
    },

    methods: {
        pesquisouTarefas(numeroTarefas) {
            this.tarefasAguardando = numeroTarefas;
        },
        toggleFilters() {
            this.filtersOpen = !this.filtersOpen
        },
        temPrivilegioSelecionarUA() {
            return verificaPrivilegio(PrivilegiosEnum.PEDIDO_SELECIONAR_OUTRA_UA);
        },
        temPrivilegioConfigurarAlmoxarifado() {
            return verificaPrivilegio(PrivilegiosEnum.GERENCIAR_ALMOXARIFADO);
        },
        temPrivilegioIncluir() {
            return verificaPrivilegio(PrivilegiosEnum.PEDIDO_INCLUIR);
        },
        handleSelectUnidadeAdministrativa(item) {
            this.form.departamento = item
            this.load();
        },
        handleSelectAlmoxarifado(item) {
            this.form.almoxarifado = item
            this.load();
        },
        handleSelectProduto(item) {
            this.form.produto = item
            this.load();
        },
        async load() {
            const filtro = {}
            this.busy = true

            if (
                this.form.produto != undefined &&
                this.form.produto.id != undefined &&
                this.form.produto.id != ""
            ) {
                filtro.produtoId = this.form.produto.id
            }
            if (
                this.form.justificativa != undefined &&
                this.form.justificativa != ""
            ) {
                filtro.justificativa = this.form.justificativa
            }
            if (this.form.descricaoExata) {
                filtro.descricaoExata = this.form.descricaoExata
            }
            if (
                this.form.pedidoId != undefined &&
                this.form.pedidoId != "" &&
                this.form.pedidoId != null
            ) {
                filtro.pedidoId = this.form.pedidoId
            }

            if (this.form.dataDe) {
                const date = new Date(this.form.dataDe)
                const year = date.getFullYear()
                const month = (date.getMonth() + 1).toString().padStart(2, "0")
                const day = date.getDate().toString().padStart(2, "0")
                filtro.dataInicio = `${month}/${day}/${year}`
            }
            if (this.form.dataAte) {
                const date = new Date(this.form.dataAte)
                const year = date.getFullYear()
                const month = (date.getMonth() + 1).toString().padStart(2, "0")
                const day = date.getDate().toString().padStart(2, "0")
                filtro.dataFim = `${month}/${day}/${year}`
            }

            if (this.form.dataDe && this.form.dataAte) {
                const ini = new Date(this.form.dataDe);
                const fim = new Date(this.form.dataAte);

                if (ini > fim) {
                    this.busy = false;
                    this.$notify({
                        type: "danger",
                        message: "Informe as datas corretamente.",
                    });
                    return;
                }
            }

            if (this.form.status != undefined && this.form.status.id != null) {
                filtro.statusId = this.form.status.id
            }
            if (
                this.form.almoxarifado != undefined &&
                this.form.almoxarifado.id != undefined &&
                this.form.almoxarifado.id != ""
            ) {
                filtro.almoxarifadoId = this.form.almoxarifado.id
            }

            if (
                this.form.departamento &&
                this.form.departamento.id != undefined
            ) {
                filtro.departamentoId = this.form.departamento.id
            } else {
                const brand = JSON.parse(localStorage.getItem("context"))
                this.form.departamento = brand.departamento
                filtro.departamentoId = this.form.departamento.id
            }

            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: filtro,
            })
                .then(response => {
                    if (response.empty == false) {
                        this.records = response.content
                        this.total = response.totalElements
                        this.totalPage = response.totalPages
                    } else {
                        this.records = []
                        this.total = 0
                        this.totalPage = 0
                    }
                })
                .finally(() => {
                    this.busy = false
                })
        },

        clearForm() {
            this.form.descricaoExata = false
            this.form.pedidoId = null
            this.form.dataDe = ""
            this.form.dataAte = ""
            this.form.justificativa = ""

            if (this.temPrivilegioConfigurarAlmoxarifado())
                this.form.almoxarifado = {}

            if (this.temPrivilegioSelecionarUA())
                this.form.departamento = {}

            this.form.produto = {}
            this.form.status = { id: null, descricao: "Selecionar" }
            this.load()
        },

        async statusList({ filter, page = 1 }) {
            return await this.$serviceStatus.findAll({ filter, page, limit: 100 })
        },

        async alteraStatus(item, statusId) {
            const { status } = this.$service.alteraStatus(item, statusId)
            if (status == 200) {
                this.$notify({
                    type: "success",
                    message: `Registro de entrada ${status.descricao}!`,
                })
            } else {
                this.$notify({
                    type: "danger",
                    message: `Erro ao alterar status para ${status.descricao}!`,
                })
                item.status = status
            }
        },

        async excluirPedido(item) {
            const value = await Swal.fire({
                title: `Excluir pedido ${item.id}?`,
                text: "Esta ação não poderá ser desfeita!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sim",
                cancelButtonText: "Não",
            }).then(({ value }) => {
                return value
            })

            if (!value) {
                return
            }

            try {
                await this.$service.remove(item.id)
                this.load()
                this.$notify({
                    type: "success",
                    message: `Pedido ${item.id} excluído!`,
                })
            } catch (err) {
                this.$notify({
                    type: "danger",
                    message: `Erro ao excluir o pedido ${item.id}!`,
                })
            }
        },

        async enviarPedido({ id }) {
            const value = await Swal.fire({
                title: `Enviar pedido ${id}?`,
                text: "Esta ação não poderá ser desfeita!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sim",
                cancelButtonText: "Não",
            }).then(({ value }) => {
                return value
            })

            if (!value) {
                return
            }

            try {
                await this.$service.post(`${id}/enviar`, {})
                this.load();
                this.$notify({
                    type: "success",
                    message: `Pedido ${id} enviado!`,
                });

            } catch (err) {
                this.$notify({
                    type: "danger",
                    message: `Erro ao enviar o pedido ${id}!`,
                })
            }
        },
        cancelar() {
            this.pedidoId = null
            this.pedido = null
            this.showModalPedidoForm = false
            this.showModalTogglePedido = false
            this.load();
        },

        canelarModalRelatorioPedidosTarefas() {
            this.showModalRelatorioPedidosTarefas = false
        },

        async editarPedido(item) {
            this.pedidoId = item.id
            this.showModalPedidoForm = true
        },

        async detalharPedido(pedido) {
            this.pedido = pedido
            this.showModalTogglePedido = true
        },

        emDigitacao(status) {
            return status.id === 26
        },

        finalizado(status) {
            return status.id === 33
        },
        formatDate(value) {
            return moment(value).format("DD/MM/yyyy")
        },
        chamarModalRelatorioPedidosTarefas(tipoArqivo) {
            this.showModalRelatorioPedidosTarefas = true
            this.tipoArqivo = tipoArqivo
        },
    },
}
</script>
<style>
.link {
    color: #0000ff;
    cursor: pointer;
}

.text-red {
    color: red;
}
</style>
